import React from "react";
import { Alert } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { hasPerm } from "../permissions";

/**
 * RequireRole — 基于权限的路由守卫
 *
 * 用法：
 *   <RequireRole user={user} perm="sales_orders">
 *     <SalesOrders />
 *   </RequireRole>
 *
 * Admin 账号始终放行。
 * 兼容旧的 allow 数组写法（过渡期）。
 */
export default function RequireRole({ user, perm, allow, children }) {
  // 未登录
  if (!user) {
    return (
      <div style={{ padding: 40 }}>
        <Alert
          type="warning"
          showIcon
          message="Login Required"
          description="Please sign in to access this page."
        />
      </div>
    );
  }

  // Admin 始终放行
  if (user.role === "admin") return children;

  // 两个条件任一满足即放行（支持 perm + allow 并用）
  const permOk  = perm  ? hasPerm(user, perm)          : false;
  const allowOk = allow ? allow.includes(user.role)     : false;

  // 至少提供了一个条件且满足
  if ((perm || allow) && (permOk || allowOk)) return children;

  return <AccessDenied />;
}

function AccessDenied() {
  return (
    <div style={{
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      minHeight: 320, gap: 16,
    }}>
      <div style={{
        width: 64, height: 64, borderRadius: "50%",
        background: "#fff1f0", border: "1px solid #ffa39e",
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <LockOutlined style={{ fontSize: 28, color: "#ff4d4f" }} />
      </div>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: "#0f1f32", marginBottom: 6 }}>
          Access Denied
        </div>
        <div style={{ fontSize: 13, color: "#8898aa", maxWidth: 300 }}>
          You don't have permission to view this page.
          Contact your administrator to request access.
        </div>
      </div>
    </div>
  );
}
